module.exports = __webpack_public_path__ + "img/back-btn.31c9876b.png";